module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-9-c052885d1360d801f8ee9ddd6559e18c.jpg";